import * as React from "react";
import { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

class ArtPostCard extends Component {
    state = {
        isHover: false,
        height: 0,
        width: 0
    };

    handleMouseOut() {
        this.setState({
            ...this.state,
            isHover: false,
        });
    }

    handleMouseOver() {
        this.setState({
            ...this.state,
            isHover: true,
        });
    }

    setDimensions({target:img}) {
        console.log("Setting dimensions", img);
        this.setState({
            height: img.offsetHeight,
            width: img.offsetWidth
        });
    }

    componentDidMount() {
        // Force preload of images
        let img = new Image();
        img.src = this.props.post.feature_image;
    }
    
    render() {
        const post = this.props.post;
        const url = `${post.slug}/`;
        if (this.state.isHover) {
            return (
                <Link to={url}>
                    {/* <header className="post-card-header"> */}
                    {post.feature_image && (
                        // <div
                        //     className="art-post-card-image"
                        //     style={{
                        //         backgroundImage: `url(${post.feature_image})`,
                        //     }}
                        // ></div>
                        <div className="art-post-card-container" onMouseOver={this.handleMouseOver.bind(this)} onMouseOut={this.handleMouseOut.bind(this)}>
                            <div style={{display: "block", width: this.state.width, height: this.state.height, backgroundColor: "#000"}}>
                                <p style={{textDecoration: "underline black", textAlign: "center", fontSize: "2em", lineHeight: "1em", paddingTop: (this.state.height/2.25), color: "#FFF", fontWeight: 800}}>{post.title}</p>
                            </div>
                        </div>
                    )}
                    {/* <h2 className="post-card-title">{post.title}</h2> */}
                    {/* </header> */}
                </Link>
            );
        } else {
            return (
                <Link to={url}>
                    {/* <header className="post-card-header"> */}
                    {post.feature_image && (
                        // <div
                        //     className="art-post-card-image"
                        //     style={{
                        //         backgroundImage: `url(${post.feature_image})`,
                        //     }}
                        // ></div>
                        <div className="art-post-card-container" onMouseOver={this.handleMouseOver.bind(this)} onMouseOut={this.handleMouseOut.bind(this)}>
                            <img src={post.feature_image} className="art-post-card-image" onLoad={this.setDimensions.bind(this)} />
                        </div>
                    )}
                    {/* <h2 className="post-card-title">{post.title}</h2> */}
                    {/* </header> */}
                </Link>
            );
        }
    }
  }

ArtPostCard.propTypes = {
    post: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        feature_image: PropTypes.string,
        featured: PropTypes.bool,
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        excerpt: PropTypes.string.isRequired,
        primary_author: PropTypes.shape({
            name: PropTypes.string.isRequired,
            profile_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default ArtPostCard;
